import { map } from "rxjs";
import HttpService from "./http.service";
import { PaginationOption } from "./http.type";
import { Test } from "@app/models/test.model";

export type TestPaginationOption = PaginationOption;

class _TestService {
  public getList(options?: TestPaginationOption) {
    return HttpService.get("/tests", {
      queryParams: { ...options },
    }).pipe(map<any, any>((response) => response));
  }

  public getDetailTest(examId: string) {
    return HttpService.get(`/tests/${examId}`).pipe(
      map<any, Test>((response) => response)
    );
  }
}

const TestService = new _TestService();

export default TestService;
